import { Tag, RVGRID_COLUMN_SIZE_OPTIONS } from "@regal-voice/ui";
import { GridColumn } from "Types/ComponentTypes/RVGridTypes";
import { Journey, JourneyWithMetrics } from "Types/Journey";

import { JourneysTags } from "../JourneysTags/JourneysTags";

export function TagsColumn({ tags, queryParams }: { tags: Array<Tag>; queryParams: any }): GridColumn<Journey> {
    return {
        size: RVGRID_COLUMN_SIZE_OPTIONS.XLARGE,
        title: (
            <div>
                <span>Tags</span>
            </div>
        ),
        dataIndex: "tags",
        // eslint-disable-next-line react/display-name
        render: (text: any, record: JourneyWithMetrics) => <JourneysTags record={record} />,
        sorter: false,
        filterMultiple: true,
        filters: tags.map((tag) => {
            return {
                text: tag.name,
                value: tag.id,
            };
        }),
        filteredValue: queryParams.filterBy?.filter((value: any) => value.key === "tags")?.[0]?.value || null,
    };
}
